import { Modal } from "@mui/material";
import { createRef, useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";
import SnackBar from "../../../../../components/Common/SnackBar";
import LoginOrSignup from "../LoginOrSignup";

const LoginOrSignupModal = ({ open, handleModalClose }) => {
  const recaptchaRef = createRef();

  const { isLoggedIn } = useSelector((state) => state.user);

  const [isCaptchaVisible, setIsCaptchaVisible] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      handleModalClose();
      setIsCaptchaVisible(true);
    } else {
      setIsCaptchaVisible(false);
    }
  }, [isLoggedIn, handleModalClose]);

  const [snackbar, setSnackbar] = useState({
    show: false,
    status: "",
    message: "",
  });

  const onCaptchaChange = (_) => {
    console.log("Captcha value:");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        className="scrollModal"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="main-form-section">
          <button
            type="button"
            className="close clse-btn"
            style={{
              color: "#fff",
              position: "relative",
              zIndex: "4",
              top: "15px",
            }}
            aria-label="Close"
            onClick={handleModalClose}
          >
            <span aria-hidden="true" style={{ color: "#fff" }}>
              <img src="/images/calculator/close.svg" />
            </span>
          </button>
          <LoginOrSignup
            toggleSnackbar={(val) => setSnackbar(val)}
            recaptchaRef={recaptchaRef}
          />
        </div>
      </Modal>

      {snackbar.show ? <SnackBar {...snackbar} onClose={setSnackbar} /> : null}
      <div style={{ display: isCaptchaVisible ? "none" : "block" }}>
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey="6LfV-WQfAAAAAA-jbkxkgzShlqBU6zImg4MZp05d"
          onChange={onCaptchaChange}
        />
      </div>
    </>
  );
};

export default LoginOrSignupModal;
